// theme.js
import { createTheme } from "@mantine/core";

export const theme = createTheme({
  colors: {
    // 10 shades from light (0) to dark (9)
    brand: [
      "#FFE8DE", // 0 - very light
      "#FFCDBD", // 1
      "#FFB199", // 2
      "#FF9474", // 3
      "#FF7F55", // 4
      "#FF6B35", // 5 ← your main color
      "#E05F30", // 6
      "#B74C26", // 7
      "#8E3A1D", // 8
      "#652814", // 9 - very dark
    ],
  },
  primaryColor: "brand", // use this palette as primary
  primaryShade: 5, // index in the brand array (matches #ff6b35)
});
